import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import { FloatInput, HeadPage } from "src/componentes";
import NFCeCode from "./NFCe.Code";
import { NFCeModalItemConsulta } from "./Modal.Item/NFCe.Modal.Item.Consulta";
import "./Styles.css";
import { NFCeModalFinalizarView } from "./Modal.Finaliza/NFCe.Modal.Finaliza.View";
import { NFCeModalItemPropriedadesView } from "./Modal.Item/NFCe.Modal.Item.Propriedades.View";

const NFCeView = () => {
  const {
    registerProdutoConsulta,
    errorsProdutoConsulta,
    handleSubmitProdutoConsulta,
    onSubmitProdutoConsulta,
    loading,
    modalShowConsultaProduto,
    dataProdutoConsulta,
    onHideModalConsultaProduto,
    onSelectModalConsultaProduto,
    onCancelModalFinaliza,
    dataProdutoNFCe,
    totalNFCe,
    descricaoProdutoConsulta,
    possuiItens,
    modalShowFinaliza,
    setModalShowFinaliza,
    dataMeioPagamento,
    onSelectModalFinaliza,
    onHideModalFinaliza,
    onSubmitNFCe,
    handleClickPropriedades,
    produtoPropriedades,
    onCancelModalPropriedades,
    modalShowPropriedades,
    onDeleteModalPropriedades,
    handleMenuClick,
    menuItens,
    handleMenuToggleClick,
  } = NFCeCode();

  return (
    <>
      <Container className="container-nfce">
        <Form
          noValidate
          onSubmit={handleSubmitProdutoConsulta(onSubmitProdutoConsulta)}
        >
          <HeadPage headText="NFCe" onToggle={handleMenuToggleClick}>
            {menuItens !== undefined &&
              menuItens.map((item) => (
                <Dropdown.Item key={item.nome} onClick={handleMenuClick(item)}>
                  {item.nome}
                </Dropdown.Item>
              ))}
          </HeadPage>
          {!loading ? (
            <>
              <Row>
                <Col xs={12}>
                  <FloatInput
                    label="Consulta"
                    errorsMessage={errorsProdutoConsulta.nome}
                    registerField={registerProdutoConsulta("nome")}
                    textAlign="center"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-center">
                  <h1>{descricaoProdutoConsulta}</h1>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  {dataProdutoNFCe && dataProdutoNFCe.length > 0 && (
                    <Table responsive hover>
                      <thead>
                        <tr>
                          <th className="col-xs-10 col-md-8">Nome</th>
                          <th className="col-02">Qtd</th>
                          <th className="col-2 text-end">Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataProdutoNFCe?.map((item, index) => (
                          <tr
                            key={index}
                            onClick={handleClickPropriedades(item)}
                            style={{ cursor: "pointer" }}
                          >
                            <td className="col-xs-12 col-md-8">
                              {item.nome} {"[" + item.codigoProduto + "]"}
                            </td>
                            <td className="col-02">
                              {item.quantidadeComercial}
                            </td>
                            <td className="col-2 text-end">
                              {(
                                item.valorUnitarioComercial *
                                item.quantidadeComercial
                              )
                                .toFixed(2)
                                .replace(".", ",")}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </Col>
              </Row>
            </>
          ) : (
            <Placeholder as={FloatingLabel} animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
          )}
        </Form>

        {possuiItens() && (
          <div className="fixed-bottom">
            <Container className="text-center py-3">
              <Button
                className="w-100"
                onClick={() => {
                  setModalShowFinaliza(true);
                }}
              >
                Finalizar {totalNFCe().toFixed(2).replace(".", ",")}
              </Button>
            </Container>
          </div>
        )}
        <NFCeModalItemConsulta
          show={modalShowConsultaProduto}
          onHide={onHideModalConsultaProduto}
          onSelect={onSelectModalConsultaProduto}
          data={dataProdutoConsulta}
        />
        <NFCeModalFinalizarView
          show={modalShowFinaliza}
          onHide={onHideModalFinaliza}
          totalNFCe={totalNFCe()}
          dataMeioPagamento={dataMeioPagamento}
          onSelect={onSelectModalFinaliza}
          onCancel={onCancelModalFinaliza}
          onSubmit={onSubmitNFCe}
        />
      </Container>
      <NFCeModalItemPropriedadesView
        show={modalShowPropriedades}
        produto={produtoPropriedades}
        onCancel={onCancelModalPropriedades}
        onDelete={onDeleteModalPropriedades}
      />
    </>
  );
};

export default NFCeView;
